var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.46 229.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -99.53,
    y: -90.12,
    width: 1035.59,
    height: 413.93
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SQR_Logo_Lockup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.11,13.91H42.89A34.44,34.44,0,0,0,8.44,48.35V185.58A34.44,34.44,0,0,0,42.89,220H180.11a34.45,34.45,0,0,0,34.45-34.44V48.35A34.45,34.45,0,0,0,180.11,13.91Zm-3,157.77a10.87,10.87,0,0,1-10.87,10.87H56.8a10.87,10.87,0,0,1-10.87-10.87V62.27A10.87,10.87,0,0,1,56.8,51.4H166.21a10.87,10.87,0,0,1,10.87,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.63,144.94a6.24,6.24,0,0,1-6.23-6.27V95a6.24,6.24,0,0,1,6.23-6.27h43.74A6.25,6.25,0,0,1,139.61,95v43.68a6.25,6.25,0,0,1-6.24,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.42,107.79C313,106,307,104.4,302.31,102.31c-8.68-3.88-12.72-9.25-12.72-16.91,0-14.49,14-21,27.94-21,13.24,0,24.82,5.47,32.59,15.42l.53.68,11.2-8.76-.53-.68C351,58,335.7,50.71,318.24,50.71c-11.63,0-22.3,3.15-30,8.85C279.55,65.94,275,75.12,275,86.11c0,25.55,24.06,31.78,43.4,36.79,19.56,5.16,31.56,9.08,31.56,24,0,14.69-11.88,24.18-30.26,24.18-9.09,0-25.92-2.41-36.5-18.57l-.49-.76-11.78,8.53.45.69c10,15.14,27.26,23.83,47.41,23.83,27.38,0,45.77-15.45,45.77-38.43C364.54,120.08,339.52,113.26,319.42,107.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M453.83,88.64v13.83c-7.61-10.32-18.89-16-32.06-16-25,0-42.54,20.21-42.54,49.16s17.49,49,42.54,49c13.26,0,24.54-5.64,32.06-16V220H467V88.64Zm-31,83.19c-14.37,0-29.72-9.55-29.72-36.35,0-17.48,7.8-36.16,29.72-36.16,18.82,0,31,14.2,31,36.16S441.67,171.83,422.85,171.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.07,88.64v51.85c0,18.16-12.43,31.34-29.55,31.34-14.23,0-21.14-8.44-21.14-25.79V88.64H490.2v60.08c0,22.5,12.23,35.93,32.71,35.93,12.76,0,23.72-5.41,31.16-15.3V182.5h13.17V88.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M628.19,86.5c-13.26,0-26.43,4.37-36.14,12l-.63.49,6.89,10.44.75-.65c8.19-7.1,20.23-9.63,28.77-9.63,4.83,0,20.6.94,20.6,13.09,0,10.74-13.1,12.75-25.77,14.69-1.57.24-3.12.48-4.64.73-9.26,1.55-30.95,5.17-30.95,28.23,0,17.74,12.53,28.77,32.71,28.77,12.37,0,22-4.22,28.65-12.55v10.4h13.18V114.37C661.61,96.92,649.11,86.5,628.19,86.5ZM621,171.83c-6.09,0-20.25-1.63-20.25-16.68,0-10.46,6.63-13.58,19.69-16l4.1-.72c8.18-1.43,17.39-3,23.86-7.08V145C648.43,164.77,634.27,171.83,621,171.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M737.86,90.42c-3.13-2.23-8.06-3.57-13.2-3.57A33.65,33.65,0,0,0,698,100.6v-12H684.8V182.5H698V132.26C698,110,710.48,100,722.87,100a24.31,24.31,0,0,1,10.52,2.23l.88.47,4.13-11.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M785.72,86.5c-25.89,0-44,20.29-44,49.33,0,29.2,18.1,48.82,45,48.82,19.1,0,30.66-9.22,37-17l.53-.64-9.54-8.51-.57.74c-6.27,8.08-15.75,12.54-26.69,12.54-19.1,0-31.53-13.34-31.86-34.05h72l.09-.77a64.9,64.9,0,0,0,.36-6.72C828.09,104.51,810.67,86.5,785.72,86.5Zm-29.63,39.72c1.78-16.49,13.18-27.08,29.28-27.08,19.52,0,27.61,13.81,28.75,27.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/SquareLogo.6e386d6afff0fe48d0b52545e9be3736.svg";
export { ForwardRef as ReactComponent };